import { RunType } from "types/generated";

export const RUN_TYPES: Record<RunType, string> = {
  UNKNOWN: "UNKNOWN",
  PROPOSED: "PROPOSED",
  TRACKED: "TRACKED",
  TASK: "TASK",
  TESTING: "TESTING",
  DESTROY: "DESTROY",
  PARSE: "PARSE",
};

export const RUN_TRIGGER_TYPES = {
  VCS_COMMIT: "vcs/commit",
  DEPENDENCY_PREFIX: "dependencies/",
  POLICY_PREFIX: "policy/",
  RECONCILIATION_PREFIX: "reconciliation/",
  MODULE_PREFIX: "module/",
} as const;
